import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cnpjMask',
})
export class CnpjMaskPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    const clean = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    return clean.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
}
